"use client";

// We can't use the FocusVisibleProvider directly from @decibeltrade/web-core because it's a server component
// and we need to use a client component to render the focus visible provider.
// This is a workaround to allow us to use the FocusVisibleProvider in a server component.

import {
  FocusVisibleProvider as WebCoreFocusVisibleProvider,
  FocusVisibleProviderProps,
} from "@decibeltrade/web-core/hooks";

export function FocusVisibleProvider(props: FocusVisibleProviderProps) {
  return <WebCoreFocusVisibleProvider {...props} />;
}
